import { render, staticRenderFns } from "./AskSSOSynchroDialog.vue?vue&type=template&id=bcd9a618&scoped=true"
import script from "./AskSSOSynchroDialog.vue?vue&type=script&lang=ts"
export * from "./AskSSOSynchroDialog.vue?vue&type=script&lang=ts"
import style0 from "./AskSSOSynchroDialog.vue?vue&type=style&index=0&id=bcd9a618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd9a618",
  null
  
)

export default component.exports